import { render, staticRenderFns } from "./majorDetail.vue?vue&type=template&id=3ad86839"
import script from "./majorDetail.vue?vue&type=script&lang=js"
export * from "./majorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports